(function () {
  // Mobile Auto-Carousel + manuelle Pfeile
  var bars = document.querySelectorAll('.aub-bar');
  bars.forEach(function (bar) {
    var cols = Array.prototype.slice.call(bar.querySelectorAll('.aub-col'));
    if (!cols.length) return;
    var idx = 0;
    cols[0].classList.add('is-active');

    var speed = parseFloat(bar.getAttribute('data-aub-speed')) || 5;
    var timer = null;
    var mobileQuery = window.matchMedia('(max-width: 749px)');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(newIdx) {
      cols[idx].classList.remove('is-active');
      idx = (newIdx + cols.length) % cols.length;
      cols[idx].classList.add('is-active');
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (!mobileQuery.matches || reduceMotion) return;
      timer = setInterval(function () {
        show(idx + 1);
      }, speed * 1000);
    }

    start();
    mobileQuery.addEventListener('change', start);

    var prevBtn = bar.querySelector('[data-aub-prev]');
    var nextBtn = bar.querySelector('[data-aub-next]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        show(idx - 1);
        start();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        show(idx + 1);
        start();
      });
    }

    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('touchstart', stop, { passive: true });
  });

  // Live Reviews.io Gesamt-Bewertung (Company + Product + Third-Party kombiniert)
  // — nutzt das geteilte assets/reviewsio-live-stats.js (sitewide via layout/theme.liquid geladen),
  // damit Announcement-Bar und Hero-Section sich einen einzigen Fetch pro Seitenaufruf teilen.
  var reviewsEls = document.querySelectorAll('[data-aub-reviews]');
  if (!reviewsEls.length || !window.IngardenReviewsStats) return;

  reviewsEls.forEach(function (el) {
    var storeId = el.getAttribute('data-store') || 'ingarden-us.myshopify.com';

    // Skeleton nach 4s entfernen, falls nie Daten ankommen (z.B. blockiert) — verhindert dauerhaftes Pulsieren
    setTimeout(function () {
      var sk = el.querySelector('.aub-skeleton');
      if (sk) sk.remove();
    }, 4000);

    window.IngardenReviewsStats.onUpdate(storeId, function (computed) {
      if (!computed) return;
      var ratingStr = computed.rating.toFixed(2).replace('.', ',');
      var countStr = computed.count.toLocaleString('de-DE');

      var ratingEl = el.querySelector('[data-aub-rating]');
      var countEl = el.querySelector('[data-aub-count]');
      if (ratingEl) ratingEl.innerHTML = '<strong>' + ratingStr + '/5</strong>';
      if (countEl) countEl.textContent = '(' + countStr + ' Rezensionen)';
    });
  });
})();
